import { render, staticRenderFns } from "./Sympton.vue?vue&type=template&id=11e6c17d&scoped=true&"
import script from "./Sympton.vue?vue&type=script&lang=js&"
export * from "./Sympton.vue?vue&type=script&lang=js&"
import style0 from "./Sympton.vue?vue&type=style&index=0&id=11e6c17d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e6c17d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
